/** Map the turn envelope to the primary project-memory bind (if any). */ export function memoryScopeFromEnvelope(envelope) {
    const fromSurface = scopeFromParts(envelope.surface, envelope.pursuitId, envelope.projectId, envelope.programId);
    if (fromSurface.scopeKind) return fromSurface;
    return {};
}
/** All unique project binds for listing (focus + pins). */ export function memoryScopesFromEnvelope(envelope) {
    const seen = new Set();
    const out = [];
    const add = (s)=>{
        if (!s.scopeKind || !s.scopeId) return;
        const key = `${s.scopeKind}:${s.scopeId}`;
        if (seen.has(key)) return;
        seen.add(key);
        out.push(s);
    };
    add(memoryScopeFromEnvelope(envelope));
    for (const pin of envelope.pins ?? []){
        add(scopeFromPin(pin));
    }
    return out;
}
function scopeFromPin(pin) {
    return scopeFromParts(pin.surface, pin.pursuitId, pin.projectId, pin.programId);
}
function scopeFromParts(surface, pursuitId, projectId, programId) {
    switch(surface){
        case 'capture_pursuit':
            if (pursuitId) return {
                scopeKind: 'pursuit',
                scopeId: pursuitId
            };
            break;
        case 'proposal':
        case 'rfi_response':
            if (projectId) return {
                scopeKind: 'zou_project',
                scopeId: projectId
            };
            break;
        case 'delivery_program':
            if (programId) return {
                scopeKind: 'program',
                scopeId: programId
            };
            break;
        default:
            if (projectId) return {
                scopeKind: 'zou_project',
                scopeId: projectId
            };
    }
    return {};
}
